export default __webpack_public_path__ + "static/media/skin_the_cat.5b33b04d.svg";